
export interface Blog {
  slug: string,
  title: string,
  image: string,
  date: string,
  author?: string,
  category?: string,
  description?: string,
}

export function Blogs({ blogs }: { blogs: Blog[] }) {
  return <div className="blogs">
    {blogs.map(blog => (
      <div className="blog-card" key={blog.slug}>
        <a href={`/blog/${blog.slug}`}>
          <div className="top">
            <img src={blog.image} alt={blog.title} />
            <h2>{blog.title}</h2>
          </div>
          <div className="bottom">
            {blog.author && <span className="author">By {blog.author}</span>}
            <time>{blog.date}</time>
            {blog.category && <span className="category">{blog.category}</span>}
            <a className="button">Read Now →</a>
          </div>
        </a>
      </div>
    ))}
  </div>
}